import { API } from "@/lib/api";
import {
  APIService,
  FetchListRequest,
  SuccessUpdateItemResponse,
} from "@/services/api";
import {
  ReadTimesheetEntry,
  WriteTimesheetEntry,
} from "@/types/timesheetEntry";

const service = new APIService<ReadTimesheetEntry, WriteTimesheetEntry>(
  API.TimesheetEntries,
);

export const TimesheetEntriesService = {
  getList: (params: FetchListRequest<ReadTimesheetEntry>) => {
    return service.getList(params);
  },
  patch: async (values: WriteTimesheetEntry[]) => {
    const response = await service.performFetch(service.path, "PATCH", values);
    await service.handleResponseError(response);
    const json =
      (await response.json()) as SuccessUpdateItemResponse<ReadTimesheetEntry>;
    return json.data;
  },
};
